<lib-system-porting
  *ngIf="system$ | async as system"
  id="system-porting"
  class="w-full"
  [onlyAdvice]="false"
  [system]="system">
</lib-system-porting>
<ng-container *ngIf="{
    updateConfiguration: updateConfiguration$ | async,
    showMeterInversion: showMeterInversion$ | async,
  } as resolved">
  <ng-container *ngIf="resolved.updateConfiguration as config">
    <section
      id="plant-configuration"
      class="custom-block">
      <section
        *ngIf="config.isConnextOffline"
        class="border-1 fx-center fx-gap-3 p-1 radius-4 radius-2 border-grey-100">
        <mat-icon class="text-orange-400">
          info
        </mat-icon>
        <customer-title-content
          class="fx-g-1"
          [content]="labels.connextDisconnectedDisclaimer">
        </customer-title-content>
      </section>
      <customer-configuration-section
        [labels]="{
          contractPowerDescription: labels.contractPowerDescription,
          contractPowerPlaceholder: labels.contractPowerPlaceholder,
          contractPowerTitle: labels.contractPowerTitle,
          externalPower: labels.externalPower,
          externalPowerConsider: labels.externalPowerConsider,
          externalPowerDescription: labels.externalPowerDescription,
          externalPowerNotConsider: labels.externalPowerNotConsider,
          externalPowerSelectionPlaceholder: labels.externalPowerSelectionPlaceholder,
          locationDescription: labels.locationDescription,
          locationTitle: labels.locationTitle,
          mapCoordinationPlaceholder: labels.mapCoordinationPlaceholder,
          meterSignDescription: labels.meterSignDescription,
          meterSignInverted: labels.meterSignInverted,
          meterSignNormal: labels.meterSignNormal,
          meterSignPlaceholder: labels.meterSignPlaceholder,
          meterSignTitle: labels.meterSignTitle,
          phaseSelectPlaceholder: labels.phaseSelectPlaceholder,
          plantCreationConnextApply: labels.plantCreationConnextApply,
          plantCreationConnextDisclaimer: labels.plantCreationConnextDisclaimer,
          plantCreationTitle: labels.plantCreationTitle,
          plantName: labels.plantName,
          plantNamePlaceholder: labels.plantNamePlaceholder,
          plantTypeDescription: labels.plantTypeDescription,
          plantTypeDisabled: labels.plantTypeDisabled,
          plantTypeTitle: labels.plantTypeTitle,
          sensorSignDescription: labels.sensorSignDescription,
          sensorSignTitle: labels.sensorSignTitle,
          singlePhase: labels.singlePhase,
          threePhase: labels.threePhase,
          monitoringModeTitle: labels.monitoringModeTitle,
          monitoringModeDescription: labels.monitoringModeDescription,
          monitoringModePlaceholder: labels.monitoringModePlaceholder,
          monitoringModeInverterMaster: labels.monitoringModeInverterMaster,
          monitoringModeMeterMaster: labels.monitoringModeMeterMaster,
          monitoringModeInternalSensor: labels.monitoringModeInternalSensor,
          monitoringModePowerMagic: labels.monitoringModePowerMagic,
          monitoringModeNone: labels.monitoringModeNone,
        }"
        [connextConfiguration]="config.connextConfiguration"
        [connextExternalConfig]="config.connextExternalConfig"
        [connextMeterConfig]="config.connextMeterConfig"
        [connextSensorConfig]="config.connextSensorConfig"
        [connextSerial]="config.connextSerial"
        [isConnextLoggerOwner]="config.isConnextLoggerOwner || config.isConnextLoggerAdmin"
        [isConnextLoggerSelected]="config.isConnextLoggerSelected"
        [isConnextOffline]="config.isConnextOffline"
        [isVerifiedMode]="false"
        [needConnextDefaultConfiguration]="false"
        [showMeterInversionInput]="resolved.showMeterInversion"
        [virtualConfiguration]="virtualConfiguration">
      </customer-configuration-section>
      <!-- Save button, only visible if the user is not the owner of the Connext Logger, if system is virtual or connext disconnected -->
      <button
        *ngIf="(!(config.isConnextLoggerOwner) && !(config.isConnextLoggerAdmin)) || config.isConnextOffline"
        menu-options
        data-testid="save-virtual-button"
        class="mt-3 custom-mat-button-primary"
        mat-button
        [disabled]="!virtualConfiguration.controls.plantName.value || !virtualConfiguration.controls.coordinates.value"
        (click)="updateSystemOnFirebase(config.system)">
        {{ 'i18n.Common.save' | translate }}
      </button>
    </section>

    <customer-users-section
      *ngIf="config.isConnextLoggerOwner"
      id="plant-users"
      class="custom-block"
      [labels]="labels"
      [connextSerial]="config.connextSerial"
      [connextUsers]="config.connextUsers">
    </customer-users-section>
    <section
      id="plant-remove"
      class="custom-block fx-row fx-gap-2 fx-align-center fx-justify-around">
      <customer-title-content
        [title]="labels.deletePlantTitle"
        [content]="labels.deletePlantContent">
      </customer-title-content>
      <button
        class="custom-mat-button-warning min-w-20"
        mat-button
        (click)="deleteSystem(config)">
        {{ labels.delete }}
      </button>
    </section>
  </ng-container>
</ng-container>
